(function ($) {

  $(document).ready(function () {
    collectionFilter.init();
  });

  var collectionFilter = {

    init: function () {

      /*
       * Initialize only when the collection filter exists.
       */
      if ($('.engoj-collection-sidebar').length === 0) {
        return;
      }

      this.bindFilters();
      this.bindClearButtons();
      this.setActiveFilters();

    },

    /*
     * Product/tag filter
     */
    bindFilters: function () {

      $('body').off(
        'click.zarufaFilter',
        '.filter-tag a:not(".clear"), .filter-tag label'
      );

      $('body').on(
        'click.zarufaFilter',
        '.filter-tag a:not(".clear"), .filter-tag label',
        function (e) {

          e.preventDefault();

          var $clicked = $(this);
          var $input = $clicked.prev('input');

          /*
           * Make sure we found the checkbox.
           */
          if (!$input.length) {
            return;
          }

          var tagName = $input.val();

          if (!tagName) {
            return;
          }

          /*
           * Read current selected tags from URL.
           */
          var params = new URLSearchParams(window.location.search);
          var currentConstraint = params.get('constraint') || '';

          var currentTags = currentConstraint
            ? currentConstraint.split('+').filter(Boolean)
            : [];

          /*
           * Check whether this tag is already selected.
           */
          var tagIndex = currentTags.indexOf(tagName);

          if (tagIndex > -1) {

            /*
             * Remove selected tag.
             */
            currentTags.splice(tagIndex, 1);

          } else {

            /*
             * Add selected tag.
             */
            currentTags.push(tagName);

          }

          /*
           * Build URL.
           */
          if (currentTags.length) {
            params.set(
              'constraint',
              currentTags.join('+')
            );
          } else {
            params.delete('constraint');
          }

          /*
           * Always return to first page after filtering.
           */
          params.delete('page');

          var newUrl =
            window.location.pathname +
            (params.toString() ? '?' + params.toString() : '');

          /*
           * Use normal Shopify page loading.
           */
          window.location.href = newUrl;

        }
      );

    },

    /*
     * Clear individual filter
     */
    bindClearButtons: function () {

      $('body').off(
        'click.zarufaFilterClear',
        '.filter-block .clear'
      );

      $('body').on(
        'click.zarufaFilterClear',
        '.filter-block .clear',
        function (e) {

          e.preventDefault();

          var params = new URLSearchParams(window.location.search);

          var $filter = $(this)
            .closest('.filter-tag');

          $filter.find('input:checked').each(function () {

            var tagName = $(this).val();

            var constraint =
              params.get('constraint') || '';

            var tags = constraint
              ? constraint.split('+').filter(Boolean)
              : [];

            var index = tags.indexOf(tagName);

            if (index > -1) {
              tags.splice(index, 1);
            }

            if (tags.length) {
              params.set(
                'constraint',
                tags.join('+')
              );
            } else {
              params.delete('constraint');
            }

          });

          params.delete('page');

          var newUrl =
            window.location.pathname +
            (params.toString() ? '?' + params.toString() : '');

          window.location.href = newUrl;

        }
      );

    },

    /*
     * Clear all filters
     */
    clearAll: function () {

      $('body').off(
        'click.zarufaFilterClearAll',
        '.refined-widgets a.clear-all'
      );

      $('body').on(
        'click.zarufaFilterClearAll',
        '.refined-widgets a.clear-all',
        function (e) {

          e.preventDefault();

          var params = new URLSearchParams(
            window.location.search
          );

          params.delete('constraint');
          params.delete('q');
          params.delete('page');

          var newUrl =
            window.location.pathname +
            (params.toString() ? '?' + params.toString() : '');

          window.location.href = newUrl;

        }
      );

    },

    /*
     * Mark selected filters visually.
     */
    setActiveFilters: function () {

      var params = new URLSearchParams(
        window.location.search
      );

      var constraint =
        params.get('constraint') || '';

      var selectedTags = constraint
        ? constraint.split('+').filter(Boolean)
        : [];

      $('.filter-tag input').each(function () {

        var $input = $(this);

        var tagName = $input.val();

        var $link = $input.next('a');

        if (selectedTags.indexOf(tagName) > -1) {

          $input.prop('checked', true);

          $link.addClass('active');

        } else {

          $input.prop('checked', false);

          $link.removeClass('active');

        }

      });

    }

  };

})(jQuery);